import { ucfirst } from '../utils';
interface FiltersProps {
    filter: string | null;
    setFilter: (n: string) => void;
    list: string[];
}
export default function CountryFilter({ filter, setFilter, list }: FiltersProps) {

    if (list.length > 1)
        return (
            <div className="filter">
                <label className='text-gray-600'>par pays :</label>
                <select className='rounded-lg bg-white p-1' value={filter || ""} onChange={e => setFilter(e.target.value)}>
                    <option value="">Tous les pays</option>
                    {list.map(country => (
                        country && <option key={country} value={country.toLowerCase()}>
                            {ucfirst(country)}
                        </option>
                    ))}
                </select>
            </div>
        );
    if (list.length === 1)
        return (
            <div className="filter">
                <label className='text-gray-600'>par pays :</label>
                <select className='rounded-lg bg-white p-1' value={filter || ""} disabled>
                    {list.map(country => (
                        country && <option key={country} value={country.toLowerCase()}>
                            {ucfirst(country)}
                        </option>
                    ))}
                </select>
            </div>
        );
    return (
        <div className="filter">
            <label className='text-gray-600'>par pays :</label>
            <select className='rounded-lg bg-white p-1' value={filter || ""} disabled>
                <option value="">Aucun disponible</option>
            </select>
        </div>
    );
};